import React from 'react';

const TABS = [
  { id: 'single', label: '单个转换' },
  { id: 'batch', label: '批量转换' },
  { id: 'mapurl', label: '地图链接解析' },
  { id: 'file', label: '文件处理' }
];

export default function CoordinateToolTabs({ activeTab, setActiveTab }) {
  return (
    <div style={{ marginBottom: 20 }}>
      {TABS.map((tab, index) => (
        <button
          key={tab.id}
          onClick={() => setActiveTab(tab.id)}
          style={{
            padding: '8px 16px',
            marginRight: index < TABS.length - 1 ? 10 : 0,
            background: activeTab === tab.id ? '#1976d2' : '#f5f5f5',
            color: activeTab === tab.id ? '#fff' : '#333',
            border: '1px solid #ddd',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}
